<!-- 
Dialog for performing a send notice task for a levy collection provider.

Shows a preview of what the notice will look like.
-->
<template>
  <dialog-base
    v-model="show"
    :levy-collection-id="levyCollectionId"
    :provider-id="providerId"
    :task="task"
    user-guide-topic="levy-collection-providers"
    user-guide-section="running-a-levy-collection-provider-task"
    size="md"
    hide-description
    @run="run"
    @hide="hide"
  >
    <notice-email-panel :notice="notice"/>
  </dialog-base>
</template>

<script>
import DialogBase from "./DialogBase.vue";
import NoticeEmailPanel from "@/components/notices/NoticeEmailPanel.vue";
import lookupMixins from "@/mixins/lookup.mixins";
import mixins from "./mixins";
import * as action from "@/store/notices/action-types";

export default {
  components: { DialogBase, NoticeEmailPanel },
  mixins: [mixins, lookupMixins],
  computed: {
    notice() {
      return this.$store.state.notices.previewSend.data;
    }
  },
  watch: {
    show(showing) {
      if (showing) {
        this.load();
      }
    }
  },
  methods: {
    async load() {
      const providerTaskType = this.lookups.providerTaskTypes.find(t => t.value == this.task.type);
      const noticeType = providerTaskType.attributeData.correspondingNotice.noticeType;
      await this.$store.dispatch(action.PREVIEW_SEND, {
        type: noticeType,
        levyCollectionId: this.levyCollectionId,
        providerId: this.providerId
      });
    }
  }
};
</script>
